export enum PayrollReportHistoryRowStatusEnum {
  Approved = 'APPROVED',
  HasDeviations = 'HAS_DEVIATIONS',
  Processing = 'PROCESSING',
}
